
















































































// import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UnitBaseData, emptyData, viewUnitInfo } from '@/api/heritageUnit/unitBase'
import UnitBaseView from './base.vue'
import UnitFilesView from './files.vue'
import UnitOwnerView from './owner.vue'
// 保护规划
import UnitProtectPlansView from './protectPlan/index.vue'
import UnitProtectPlanView from './protectPlan/info.vue'
// 保护工程
import UnitProjectsView from './project/index.vue'
import UnitProjectView from './project/info.vue'
//保护工程 方案实施
import UnitProjectImplementView from './project/implement.vue'
// 组成部分
import UnitPartsView from './part/index.vue'
import UnitPartView from './part/info.vue'
//四有情况
import UnitFourView from './four/index.vue'
// 考古调查与发掘
import UnitArchaeologysView from './archaeology/index.vue'
import UnitArchaeologyView from './archaeology/info.vue'
// 安全与执法
import UnitSafetyChecksView from './safetyCheck/index.vue'
import UnitSafetyCheckView from './safetyCheck/info.vue'
// 展示利用
import UnitExibitionsView from './exibition/index.vue'
import UnitExibitionView from './exibition/info.vue'

import UnitVideosView from './video/index.vue'

import UnitActionsView from './actions.vue'
import UnitRiskView from './unitRisk.vue'

import { showUnitFour } from '@/configs/webConfig'
import ViewDialog from '@/components/dialog/viewDialog.vue'
//import ViewLink from '@/components/viewLink.vue'

@Component({
  components: {
    ViewDialog, UnitBaseView, UnitFilesView, UnitOwnerView, UnitFourView,
    UnitProtectPlansView, UnitProtectPlanView,
    UnitProjectsView, UnitProjectView, UnitProjectImplementView,
    UnitPartsView, UnitPartView,
    UnitArchaeologysView, UnitArchaeologyView,
    UnitSafetyChecksView, UnitSafetyCheckView,
    UnitExibitionsView, UnitExibitionView,
    UnitVideosView,
    UnitActionsView, UnitRiskView
  }
})
export default class UnitInfoView extends Vue {
  public tabName: string = 'baseInfo'
  public showDialog: boolean = false
  public loading: boolean = false

  public showFour = showUnitFour
  public hasFiles: boolean = false
  public picForm: any = {
    Pictures: [],
    Drawings: []
  }
  public form: UnitBaseData = Object.assign({}, emptyData)
  public $refs!: {
    filesCtrl: UnitFilesView,
    ownerCtrl: UnitOwnerView,
    partCtrl: UnitPartsView,
    fourCtrl: UnitFourView,
    planCtrl: UnitProtectPlansView,
    projectCtrl: UnitProjectsView,
    archaeologyCtrl: UnitArchaeologysView,
    safetyCheckCtrl: UnitSafetyChecksView,
    exibitionCtrl: UnitExibitionsView
    videoCtrl: UnitVideosView
  }
  public tabClick(tab: any, event: any) {
    const tabName = tab.name
    if (tabName == 'owner') {
      if (this.$refs.ownerCtrl) {
        this.$refs.ownerCtrl.loadData(this.form.Id)
      }
    }
    if (tabName == 'four') {
      if (this.$refs.fourCtrl) {
        this.$refs.fourCtrl.loadData(this.form.Id)
      }
    }
    if (tabName == 'project') {
      if (this.$refs.projectCtrl) {
        this.$refs.projectCtrl.loadData(this.form.Id)
      }
    }
    if (tabName == 'plan') {
      if (this.$refs.planCtrl) {
        this.$refs.planCtrl.loadData(this.form.Id)
      }
    }
    if (tabName == 'part') {
      if (this.$refs.partCtrl) {
        this.$refs.partCtrl.loadData(this.form.ListId)
      }
    }
    if (tabName == 'archaeology') {
      if (this.$refs.archaeologyCtrl) {
        this.$refs.archaeologyCtrl.loadData(this.form.Id)
      }
    }
    if (tabName == 'safetyCheck') {
      if (this.$refs.safetyCheckCtrl) {
        this.$refs.safetyCheckCtrl.loadData(this.form.Id)
      }
    }
    if (tabName == 'exibition') {
      if (this.$refs.exibitionCtrl) {
        this.$refs.exibitionCtrl.loadData(this.form.Id)
      }
    }
    if (tabName == 'videos') {
      if (this.$refs.videoCtrl) {
        this.$refs.videoCtrl.loadData(this.form.Id)
      }
    }
  }
  public created() {
  }
  public mounted() {
    window.eventBus.$on('viewHeritageUnit', (id: number) => {
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewHeritageUnit')
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    viewUnitInfo(id).then((response: { data: any }) => {
      var data = response.data
      if (data) {
        if (data.IsOtherUnit) {
          console.log('打开其他单位明细')
          window.eventBus.$emit('viewOtherUnit', id)
        }
        else if (data.IsPart) {
          console.log('打开组成部分明细')
          window.eventBus.$emit('viewUnitPart', id)
        }
        else {
          this.form = response.data
          this.setPic()
          this.tabName = 'baseInfo'
          this.showDialog = true
        }
      }
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public setPic() {
    const pic = this.form.Pictures
    const draw = this.form.Drawings
    this.hasFiles = pic.length > 0 || draw.length > 0
    this.picForm = {
      Pictures: pic,
      Drawings: draw
    }
    if (this.hasFiles) {
      this.$nextTick(() => {
        this.$refs.filesCtrl.setForm(this.picForm)
      })
    }
  }
}
